/* RESPONSIBLE TEAM: team-ai-agent-2 */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneProcedureSimulationsTestRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneProcedureSimulationsTestRoute, {
  overrideRenderTemplate: false,
});
